import { Component, Input, OnInit, OnDestroy } from '@angular/core'
// import { NgbNav, NgbNavItem, NgbNavLink, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap'

import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { FormGroup, FormControl } from '@angular/forms'
import { PjudService } from '../services/pjud.service';
import { brand } from '@app/branding/brand';


export interface Customer {
  name: string;
  email: string;
  identification: string;
}


@Component({
    selector: 'app-pjud',
    templateUrl: './pjud.component.html',
    styleUrls: ['./pjud.component.scss'],
    standalone: false
})
export class PjudComponent implements OnInit, OnDestroy {

  @Input() rit : string = '';
  @Input() tribunal : string = '';
  @Input() court : string = '';
  @Input() competencie : string = '';
  @Input() customer : Customer;
  @Input() portalUrl : string = '';

  @Input() rit_recurso : string = '';
  @Input() tribunal_recurso : string = '';
  @Input() court_recurso : string = '';
  @Input() competencie_recurso : string = '';
  @Input() book : string = '';

  @Input() type : string = '1raInstancia';

  // ── Corregir y reintentar ──────────────────────────────────────────────
  // Cuando la causa trae error de datos (no encontrada / tribunal inválido / sin movimientos),
  // el cliente puede corregir RIT/tribunal/competencia acá mismo y reintentar la conexión.
  // Al reintentar reenviamos /robotpjud/save (→ registerCause), que resetea el error y reencola.
  @Input() competencieOptions: string[] = [];
  showCorrection = false;
  correctionSaving = false;
  correction = { rit: '', tribunal: '', competencie: '', book: '' };

  activeContentTab = "Movimientos"
  activeTabIds = [1]; // Controla qué tab principal está activo (1 = 1ra Instancia por defecto)
  page = 1
  pageSize = 10
  searchingCauseData = true
  searchingCauseDataApelacion = true
  selectedCause: any[] = [];
  headerInfo: any[] = [];
  tableCause: any[] = [];
  selectedCauseApelacion: any[] = [];
  headerInfoApelacion: any[] = [];
  tableCauseApelacion: any[] = [];
  menssge1raInstancia: string = '';
  menssgeApelacion: string = '';
  sendP: boolean = false;
  mostrarA:boolean = true;
  recurso = false;
  textA: string = brand.messages.pjudAddCause;

  // Seguimiento del estado en la cola tras registrar (el robot encola y scrapea async con prioridad
  // máxima). Refrescamos /robotpjud/get hasta que aparezcan los movimientos o se finalice.
  private pollTimer: any = null;
  private pollCount = 0;
  private readonly MAX_POLLS = 10;
  private readonly POLL_INTERVAL_MS = 15000;
  polling = false;

  // Propiedades para el filtro por libro
  uniqueBooks: string[] = [];
  selectedBook: string = '';
  filteredMovements: any[] = [];
  originalMovements: any[] = [];

  // Propiedades para el filtro por libro en apelaciones
  uniqueBooksApelacion: string[] = [];
  selectedBookApelacion: string = '';
  filteredMovementsApelacion: any[] = [];
  originalMovementsApelacion: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private pjudService: PjudService
  ) { }

  ngOnInit() {
    this.searchRobot();
  }

  setActiveTab(tabId: number) {
    this.activeTabIds = [tabId];
  }
  async searchRobot(){
    try {
      const data = await this.pjudService.getCauseForRit(this.rit,this.tribunal,this.court,this.competencie,this.book, this.customer);
    const resp = data.result;      
    if(!resp.success) {
      this.menssge1raInstancia = resp.message;
    }else {
      this.setResponse(resp.cause);
        
        if(resp.second_instance_case){
          this.recurso = true;
          this.setResponseApelacion(resp.second_instance_case);
        }
      }
    } catch (error) {
      console.error('Error al buscar causa:', error);
      this.menssge1raInstancia = 'Error al procesar la solicitud.';
    }
    
    if (!this.selectedCauseApelacion || !this.selectedCauseApelacion['data']){
      if(this.rit_recurso && this.tribunal_recurso && this.court_recurso && this.competencie_recurso){
        this.recurso = true;
          try {
            const data: any = await this.pjudService.getCauseForRit(this.rit_recurso,this.tribunal_recurso,this.court_recurso,this.competencie_recurso,this.book, this.customer);
          const resp = data.result;
          if(!resp.success) {
            this.menssgeApelacion = resp.message;
          }else {
              this.setResponseApelacion(resp.cause);
          }
          } catch (error) {
            console.error('Error al buscar causa de apelación:', error);
            this.menssgeApelacion = 'Error al procesar la solicitud de apelación.';
          }
      } else {
        this.recurso = false;
      }
    }



  }

  /**
   * Actualiza o registra la causa en el robot pjud, proceso corre en 2do plano
   */
  saveCauseRobotPjud(){
    this.sendP = true;
    this.menssge1raInstancia = 'Solicitud enviada. La causa quedó en cola con prioridad alta; en unos minutos la información aparecerá aquí.';
    this.mostrarA = false;
    let obj = {
      'rit': this.rit,
      'competencie': this.competencie,
      'court':this.court,
      'customer': this.customer,
      'portalUrl': this.portalUrl
    };
    if (this.competencie === 'Corte Apelaciones') {
      obj['book'] = this.book;
    } else {
      obj['tribunal'] = this.tribunal;
    }

    this.pjudService.saveCause(obj).subscribe((data:any) => {
      const resp = data.result;
      if(resp && resp.message){
        this.menssge1raInstancia = resp.message;
      }
      // Encolada (async): seguimos el estado desde la cola hasta que aparezcan los movimientos.
      this.startStatusPolling();
    })
  }

  /**
   * ¿La causa está en un estado de error de datos que el cliente puede corregir?
   * (no encontrada, tribunal/competencia inválidos, o sincronizó sin traer movimientos).
   * Se usa para ofrecer el panel "Corregir datos y reintentar".
   */
  get hasDataError(): boolean {
    const cause = this.selectedCause && this.selectedCause['data'];
    if (cause) {
      const err = cause['errorType'];
      const terminal = ['not_found', 'not_found_confirmed', 'configuration_error',
        'reserved_cause', 'max_retries_exceeded_critical', 'credential_no_access'];
      if (err && terminal.includes(err)) return true;
      // Conectó pero sin movimientos: típico de RIT/tribunal equivocado.
      const noMovs = cause['scrapingstatus'] === 'Finalizado'
        && (!cause['causesMovements'] || cause['causesMovements'].length === 0);
      if (noMovs) return true;
    }
    // Sin datos de causa (nunca se pudo leer) y ya llegó un mensaje de error del robot.
    return this.searchingCauseData && !!this.menssge1raInstancia && !this.polling;
  }

  /** Abre el panel de corrección precargando los valores actuales para que el cliente los edite. */
  openCorrection() {
    this.correction = {
      rit: this.rit || '',
      tribunal: this.tribunal || '',
      competencie: this.competencie || '',
      book: this.book || '',
    };
    this.showCorrection = true;
  }

  cancelCorrection() {
    this.showCorrection = false;
  }

  get canSubmitCorrection(): boolean {
    const c = this.correction;
    if (!c.rit || !c.rit.trim() || !c.competencie || !c.competencie.trim()) return false;
    // Corte Apelaciones usa "book"; el resto requiere tribunal.
    return c.competencie === 'Corte Apelaciones' ? !!(c.book && c.book.trim()) : !!(c.tribunal && c.tribunal.trim());
  }

  /**
   * Guarda los datos corregidos y reintenta la conexión.
   * Reenvía /robotpjud/save con los valores editados: el robot (registerCause) actualiza el
   * tribunal/book de la causa existente, limpia el errorType y la reencola con prioridad alta.
   */
  retryWithCorrection() {
    if (!this.canSubmitCorrection || this.correctionSaving) return;
    this.correctionSaving = true;

    // Aplicamos la corrección a los inputs para que searchRobot/polling usen los nuevos valores.
    this.rit = this.correction.rit.trim();
    this.competencie = this.correction.competencie.trim();
    if (this.competencie === 'Corte Apelaciones') {
      this.book = (this.correction.book || '').trim();
    } else {
      this.tribunal = (this.correction.tribunal || '').trim();
    }

    const obj: any = {
      rit: this.rit,
      competencie: this.competencie,
      court: this.court,
      customer: this.customer,
      portalUrl: this.portalUrl,
    };
    if (this.competencie === 'Corte Apelaciones') {
      obj.book = this.book;
    } else {
      obj.tribunal = this.tribunal;
    }

    this.sendP = true;
    this.mostrarA = false;
    this.showCorrection = false;
    this.menssge1raInstancia = 'Datos corregidos. Reintentando la conexión: la causa quedó en cola con prioridad alta.';

    this.pjudService.saveCause(obj).subscribe({
      next: (data: any) => {
        const resp = data && data.result;
        if (resp && resp.message) {
          this.menssge1raInstancia = resp.message;
        }
        this.correctionSaving = false;
        this.startStatusPolling();
      },
      error: () => {
        this.correctionSaving = false;
        this.menssge1raInstancia = 'No se pudo reintentar la conexión. Revisa los datos e inténtalo nuevamente.';
      },
    });
  }

  saveCauseRobotPjudApelacion(){
    this.sendP = true;
    this.menssgeApelacion = 'Solicitud enviada. La causa quedó en cola con prioridad alta; en unos minutos la información aparecerá aquí.';
    this.mostrarA = false;
    let obj = {
      'rit': this.rit_recurso,
      'tribunal': this.tribunal_recurso,
      'competencie': this.competencie_recurso,
      'court':this.court_recurso,
      'customer': this.customer,
      'portalUrl': this.portalUrl,
      'book': this.book,
    }
    this.pjudService.saveCause(obj).subscribe((data:any) => {
      const resp = data.result;
      if(resp && resp.message) {
        this.menssgeApelacion = resp.message;
      }
      // Encolada (async): searchRobot refresca también la vista de apelación.
      this.startStatusPolling();
    })
  }

  /**
   * Refresca el estado de la causa desde la cola (/robotpjud/get) hasta que el worker termine el
   * scrapeo (aparecen movimientos o scrapingstatus='Finalizado') o se agoten los intentos.
   */
  private startStatusPolling(){
    this.stopStatusPolling();
    this.pollCount = 0;
    this.polling = true;
    const tick = async () => {
      this.pollCount++;
      await this.searchRobot();
      const cause = this.selectedCause && this.selectedCause['data'];
      const done = cause && (cause['scrapingstatus'] === 'Finalizado' ||
        (cause['causesMovements'] && cause['causesMovements'].length > 0));
      if (done || this.pollCount >= this.MAX_POLLS) {
        this.stopStatusPolling();
        return;
      }
      this.pollTimer = setTimeout(tick, this.POLL_INTERVAL_MS);
    };
    this.pollTimer = setTimeout(tick, this.POLL_INTERVAL_MS);
  }

  private stopStatusPolling(){
    if (this.pollTimer) { clearTimeout(this.pollTimer); this.pollTimer = null; }
    this.polling = false;
  }

  ngOnDestroy(){
    this.stopStatusPolling();
  }

  setResponse(cause:any){
    this.sendP = false;
    this.searchingCauseData = false;
    if(cause["causesMovements"].length == 0) {
      this.searchingCauseData = true;
      if(cause["scrapingstatus"] == 'En progreso'){
        this.mostrarA = false;
      }
      this.menssge1raInstancia = cause["scrapingdescription"] ? cause["scrapingdescription"] : 'No se encontraron movimientos registrados.';
    }
    this.selectedCause["data"] = cause;

    // Guardar los movimientos originales y filtrados
    this.originalMovements = cause["causesMovements"];
    this.filteredMovements = [...this.originalMovements];

    // Obtener libros únicos
    this.uniqueBooks = this.getUniqueBooks(this.originalMovements);

    this.tableCause.push({ title: 'Movimientos', data: this.filteredMovements});
    this.tableCause.push({ title: 'Litigantes', data: cause["causesDetails"]});
    this.tableCause.push({ title: 'Notificaciones', data: []});
    this.tableCause.push({ title: 'Diligencias', data: []});
    this.tableCause.push({ title: 'Liquidación', data: []});
    this.tableCause.push({ title: 'Materias', data: []});
    this.dataExtra(cause);
  }

  dataExtra(data): void{
    for (const property in data.infoExtra) {
      this.headerInfo.push({key:property,value:data.infoExtra[property]});
    }
  }

  setResponseApelacion(cause:any){
    this.sendP = false;
    this.searchingCauseDataApelacion = false;
    if(cause["causesMovements"].length == 0) {
      this.searchingCauseDataApelacion = true;
      if(cause["scrapingstatus"] == 'En progreso'){
        this.mostrarA = false;
      }
      this.menssgeApelacion = cause["scrapingdescription"] ? cause["scrapingdescription"] : 'No se encontraron movimientos registrados.';
    }
    this.selectedCauseApelacion["data"] = cause;

    // Guardar los movimientos originales y filtrados para apelaciones
    this.originalMovementsApelacion = cause["causesMovements"];
    this.filteredMovementsApelacion = [...this.originalMovementsApelacion];

    // Obtener libros únicos para apelaciones
    this.uniqueBooksApelacion = this.getUniqueBooks(this.originalMovementsApelacion);

    this.tableCauseApelacion.push({ title: 'Movimientos', data: this.filteredMovementsApelacion});
    this.tableCauseApelacion.push({ title: 'Litigantes', data: cause["causesDetails"]});
    this.tableCauseApelacion.push({ title: 'Notificaciones', data: []});
    this.tableCauseApelacion.push({ title: 'Diligencias', data: []});
    this.tableCauseApelacion.push({ title: 'Liquidación', data: []});
    this.tableCauseApelacion.push({ title: 'Materias', data: []});
    this.dataExtraApelacion(cause);
  }
  dataExtraApelacion(data): void{
    for (const property in data.infoExtra) {
      this.headerInfoApelacion.push({key:property,value:data.infoExtra[property]});
    }
  }
  openModalDoc(content?) {
    this.modalService.open(content, { size: 'xl' });
  }

  // Método para obtener libros únicos
  getUniqueBooks(movements: any[]): string[] {
    const books = movements.map(movement => movement.book).filter(book => book);
    const uniqueBooks = [...new Set(books)];
    return uniqueBooks.sort(); // Ordenar alfabéticamente
  }

  // Método para filtrar por libro
  filterByBook() {
    if (this.selectedBook === '') {
      this.filteredMovements = [...this.originalMovements];
    } else {
      this.filteredMovements = this.originalMovements.filter(movement => movement.book === this.selectedBook);
    }

    // Actualizar la tabla de movimientos
    const movementsTab = this.tableCause.find(tab => tab.title === 'Movimientos');
    if (movementsTab) {
      movementsTab.data = this.filteredMovements;
    }
  }

  // Método para filtrar por libro en apelaciones
  filterByBookApelacion() {
    if (this.selectedBookApelacion === '') {
      this.filteredMovementsApelacion = [...this.originalMovementsApelacion];
    } else {
      this.filteredMovementsApelacion = this.originalMovementsApelacion.filter(movement => movement.book === this.selectedBookApelacion);
    }

    // Actualizar la tabla de movimientos de apelaciones
    const movementsTab = this.tableCauseApelacion.find(tab => tab.title === 'Movimientos');
    if (movementsTab) {
      movementsTab.data = this.filteredMovementsApelacion;
    }
  }

}
